<template>
  <header>
    <!-- <div class="header-top">
      <div class="main-center clearfix">
        <div class="fl">
          <ul class="clearfix">
            <li v-for="(item, index) in links" :key="index">
              <a v-if="item.target" :href="item.url" :target="item.target">{{ item.title }}</a>
              <a v-else :href="item.url">{{ item.title }}</a>
            </li>
          </ul>
        </div>
        <div class="fr">
          <div class="greetings" v-if="islogin">您好，{{ username }}!</div>
        </div>
      </div>
    </div>-->
    <div class="header-navbar">
      <div class="main-center clearfix">
        <div class="logo">
          <a href="https://www.xunfei.cn/">
            <img src="https://img.xunfei.cn/mall/ifly-mall-lsd/logo.png" alt />
          </a>
        </div>
        <ul class="nav clearfix">
          <li v-for="(item, index) in nav" :key="index">
            <a v-if="item.target" :href="item.url" :target="item.target">{{ item.title }}</a>
            <a v-else :href="item.url">{{ item.title }}</a>
            <i class="newest" v-if="item.isnew"></i>
          </li>
        </ul>
        <!-- <div class="searchbar">
          <input name="keywords" type="text" id="keyword" placeholder="阿尔法蛋" autocomplete="off" />
          <div class="icon-wrap">
            <i class="icon"></i>
          </div>
        </div> -->
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "TheHeader",
  data() {
    return {
      links: [
        { title: "首页", url: "//www.xunfei.cn/", target: null },
        {
          title: "科大讯飞官网",
          url: "https://www.iflytek.com/index.html",
          target: "_blank",
        },
        // { title: '飞粉之家', url: 'https://club.xunfei.cn/', target: '_blank' },
        // {
        //   title: '企业购',
        //   url: 'http://x.xunfei.cn/mall/corporatePurchase.html',
        //   target: '_blank'
        // },
        // {
        //   title: '零售店',
        //   url: 'http://x.xunfei.cn/mall/tyd.html',
        //   target: '_blank'
        // },
        // {
        //   title: 'VIP码通道',
        //   url: 'https://www.xunfei.cn/fcode',
        //   target: '_blank'
        // },
        // {
        //   title: '解决方案',
        //   url: '//www.xunfei.cn/category.php?id=17',
        //   target: '_blank'
        // }
      ],
      nav: [
        {
          title: "首页",
          url: "https://www.xunfei.cn",
          isnew: false,
          target: "_blank",
        },
        {
          title: "科大讯飞官方商城",
          url: "https://www.xunfei.cn/",
          isnew: false,
          target: "_blank",
        },
        // {
        //   title: "飞粉之家",
        //   url: "https://club.xunfei.cn/",
        //   isnew: false,
        //   target: "_blank",
        // },
        // {
        //   title: "企业购",
        //   url: "https://www.xunfei.cn/company",
        //   isnew: false,
        //   target: "_blank",
        // },
        // {
        //   title: "零售店",
        //   url: "https://www.xunfei.cn/ifly-mall-lsd/",
        //   isnew: false,
        //   target: "_blank",
        // },
        // {
        //   title: "VIP码通道",
        //   url: "https://www.xunfei.cn/fcode",
        //   isnew: false,
        //   target: "_blank",
        // },
      ],
      islogin: true,
      username: "18010855044",
    };
  },
};
</script>

<style lang="less" scoped>
.header-top {
  height: 36px;
  line-height: 30px;
  background: #333333;
  width: 100%;
  color: #ccc;
  .fl {
    float: left;
    li {
      float: left;
      position: relative;
      font-size: 12px;
      &:not(:last-child)::after {
        position: absolute;
        display: block;
        content: '';
        width: 1px;
        height: 12px;
        background-color: #b1b1b1;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      a {
        display: block;
        line-height: 30px;
        padding: 0 10px;
        color: #b1b1b1;
        &:hover {
          color: #00adde;
        }
      }
    }
  }
  .fr {
    float: right;
    .greetings {
      color: #b1b1b1;
      font-size: 12px;
      line-height: 30px;
    }
  }
}
.header-navbar {
  position: relative;
  z-index: 80;
  height: 82px;
  background-color: #ffffff;
  .main-center {
    height: 82px;
    .logo {
      float: left;
      position: relative;
      z-index: 77;
      width: 260px;
      padding-top: 15px;
      padding-right: 30px;
      img {
        width: 176px;
        height: auto;
      }
    }

    .nav {
      float: left;
      margin-top: 28px;
      li {
        float: left;
        cursor: pointer;
        height: 54px;
        a {
          margin-left: 15px;
          margin-right: 1px;
          line-height: 30px;
          cursor: pointer;
          font-size: 16px;
          text-align: center;
          color: #3a3a3a;
          border-bottom: 2px solid #fff;
        }
        &:hover {
          a {
            color: #00adde;
            border-bottom: 2px solid #00adde;
          }
        }
        .newest {
          width: 30px;
          height: 16px;
          display: inline-block;
          background: url('~@/assets/svg/newest_icon.svg')
            no-repeat left 0px;
          position: relative;
          top: -5px;
          margin-right: 6px;
        }
      }
    }

    .searchbar {
      float: right;
      width: 300px;
      margin-top: 23px;
      height: 30px;
      line-height: 1;
      background: #fafafa;
      border-radius: 15px;
      position: relative;
      input {
        float: left;
        border: 0px;
        background: none;
        line-height: 30px;
        height: 30px;
        padding-left: 15px;
        font-size: 12px;
        color: #757575;
        outline: none;
        width: 272px;
      }
      .icon-wrap {
        float: left;
        width: 28px;
        padding: 7px 0;
      }
      .icon {
        float: left;
        display: block;
        border: 0px;
        background: url('~@/assets/svg/icon-common.svg')
          no-repeat center;
        width: 16px;
        line-height: 30px;
        height: 16px;
        color: #fff;
        text-align: center;
        font-size: 0px;
        cursor: pointer;
      }
    }
  }
}
</style>
